export default "__VITE_ASSET__BUeMFr1v__"